import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ArrowDropDownIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path d="M11.475 14.475L7.84995 10.85C7.79995 10.8 7.76245 10.7458 7.73745 10.6875C7.71245 10.6292 7.69995 10.5667 7.69995 10.5C7.69995 10.3667 7.74578 10.25 7.83745 10.15C7.92912 10.05 8.04995 10 8.19995 10H15.8C15.95 10 16.0708 10.05 16.1625 10.15C16.2541 10.25 16.3 10.3667 16.3 10.5C16.3 10.5333 16.25 10.65 16.15 10.85L12.525 14.475C12.4416 14.5583 12.3583 14.6167 12.275 14.65C12.1916 14.6833 12.1 14.7 12 14.7C11.9 14.7 11.8083 14.6833 11.725 14.65C11.6416 14.6167 11.5583 14.5583 11.475 14.475Z" fill={color} />

    </svg>
  );
};

export default ArrowDropDownIcon;
